import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "id",
        headerName: "ID",
        minWidth: window.innerWidth * 0.05,
        valueGetter: "node.rowIndex + 1",
        flex: 0.5,
        filter: true,
    },
    {
        field: "itemDetails",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "unit",
        headerName: "Unit",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "natureOfJobWork",
        headerName: "Nature of job work",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];

export const JwOutPopup = (props) => {
    return (
        <ModalBasic
            id="jw-out"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material job work out details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Job work no</label>
                        <TextInput type='text'
                            id='jobWorkNo' name='jobWorkNo'
                            value={props.jwObject.jobWorkNo}
                            handleChange={(event) => props.handleChangeForJw(event, 'jobWorkNo')}
                            className={props.validState?.error?.jobWorkNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Job work date</label>
                        <TextInput type='date'
                            id='jobWorkDate' name='jobWorkDate'
                            value={props.jwObject.jobWorkDate}
                            handleChange={(event) => props.handleChangeForJw(event, 'jobWorkDate')}
                            className={props.validState?.error?.jobWorkDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp '>
                        <label>Type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.jwObject.typeList}
                            value={props.jwObject.idType ? props.jwObject.typeList.find(x => x.value === props.jwObject.idType) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idType")
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth. employee</label>
                        <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.employeeList}
                            value={props.jwObject.idEmployee ? props.employeeList.find(x => x.value === props.jwObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idEmployee")
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select vendor</label>
                        <MultiSelectDropdown
                            drpIdentity="Select vendor"
                            options={props.partyList}
                            value={props.jwObject.idParty ? props.partyList.find(x => x.value === props.jwObject.idParty) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idParty")
                            }
                            className={props.validState?.error?.idParty !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.jwObject.remarks}
                            handleChange={(event) => props.handleChangeForJw(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-inner grid grid-cols-5 items-start gap-2.5 mt-2'>
                    <div className='input-grp col-span-2'>
                        <label>Item</label>
                        <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.itemObject.itemList}
                            value={props.itemObject.idItem ? props.itemObject.itemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idItem")
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Unit</label>
                        <TextInput type='number'
                            id='unit' name='unit'
                            value={props.itemObject.unit}
                            handleChange={(event) => props.handleChange(event, 'unit')}
                            className={props.validState?.error?.unit !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChange(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChange(event, 'amount')}
                            className={props.validState?.error?.amount !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp '>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select tax"
                            options={props.itemObject.taxList}
                            value={props.itemObject.idTax ? props.itemObject.taxList.find(x => x.value === props.itemObject.idTax) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idTax")
                            }
                            className={props.validState?.error?.idTax !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>CGST</label>
                        <TextInput type='text'
                            id='cgst' name='cgst'
                            value={props.itemObject.cgst}
                            handleChange={(event) => props.handleChange(event, 'cgst')}
                            className={props.validState?.error?.cgst !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>SGST</label>
                        <TextInput type='text'
                            id='sgst' name='sgst'
                            value={props.itemObject.sgst}
                            handleChange={(event) => props.handleChange(event, 'sgst')}
                            className={props.validState?.error?.sgst !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>IGST</label>
                        <TextInput type='text'
                            id='igst' name='igst'
                            value={props.itemObject.igst}
                            handleChange={(event) => props.handleChange(event, 'igst')}
                            className={props.validState?.error?.igst !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Total</label>
                        <TextInput type='text'
                            id='total' name='total'
                            value={props.itemObject.total}
                            handleChange={(event) => props.handleChange(event, 'total')}
                            className={props.validState?.error?.total !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Nature of job work</label>
                        <TextInput type='text'
                            id='nature' name='nature'
                            value={props.itemObject.nature}
                            handleChange={(event) => props.handleChange(event, 'nature')}
                            className={props.validState?.error?.nature !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.itemObject && props.itemObject.index === null ?
                            <div className='flex items-center gap-2.5'>
                                <button className="save-btn btns mt-auto mb-[2px] h-[40px]" onClick={() => props.insertItem("Insert")}> Insert</button>
                                <button className="edit-btn btns mt-auto mb-[2px] h-[40px]" onClick={() => props.deleteItem()}> Clear</button>
                            </div>
                            :
                            <div className="flex items-center gap-2.5">
                                <button className="save-btn btns mt-auto mb-[2px] h-[40px]" onClick={() => props.insertItem("Update")}> Update</button>
                                <button className="delete-btn btns mt-auto mb-[2px] h-[40px]" onClick={() => props.deleteItem()}> Delete</button>
                            </div>
                        }
                    </div>
                </div>
                <div className="process-table h-[30vh] mt-5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}